import { CardString } from 'pokersolver'

import { WalkthroughPlayersIds } from './'
import { Platform } from 'react-native'

export type TableTourStep = {
  id: undefined | 'D' | 'SB' | 'BB' | 'hole' | 'chips' | 'pot' | 'no_of_suits' | 'cards_in_suit' | 'layout'
  title: string
  description: string
  marginBottom: `${number}%` | undefined
  line:
    | {
        type: 'clockwise' | 'counterclockwise'
        rotation: number
        horizontalPosition: 'right' | 'left'
        verticalPosition: 'bottom' | 'top'
      }
    | undefined
}

export const TableTourCards: () => Record<WalkthroughPlayersIds, CardString[]> = () => ({
  bettina: ['Qd', 'Qh'],
  esther: ['As', 'Ks'],
  dianne: ['7c', '6h'],
  jane: ['8h', '9h'],
  tara: ['Ah', '6d']
})

export const TableTourSteps: TableTourStep[] = [
  {
    id: undefined,
    title: '',
    description: '',
    marginBottom: undefined,
    line: undefined
  },
  {
    id: 'no_of_suits',
    title: 'There are 4 suits:',
    description: '',
    marginBottom: undefined,
    line: undefined
  },
  {
    id: 'cards_in_suit',
    title: 'There are 13 cards in each suit.',
    description: '',
    marginBottom: undefined,
    line: undefined
  },
  {
    id: 'layout',
    title: 'Now, let’s talk about the layout of the positions and Poker table elements.',
    description: '',
    marginBottom: undefined,
    line: undefined
  },
  {
    id: undefined,
    title: '',
    description: '',
    marginBottom: undefined,
    line: undefined
  },
  {
    id: undefined,
    title: '',
    description: '',
    marginBottom: undefined,
    line: undefined
  },
  {
    id: 'D',
    title: 'Dealer Button',
    description:
      'The Button in poker is a strategic sweet spot. As the last to act, it offers control and a crucial timing advantage. This position moves one to the left every hand.',
    marginBottom: undefined,
    line: {
      type: 'clockwise',
      rotation: 0,
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    }
  },
  {
    id: 'SB',
    title: 'Small Blind',
    description:
      "The Small Blind initiates the betting, making the initial wager with style, regardless of your cards. Typically, it's half the Big Blind. This position moves one to the left every hand.",
    marginBottom: Platform.OS === 'web' ? undefined : '50%',
    line: {
      type: 'counterclockwise',
      rotation: 0,
      horizontalPosition: 'left',
      verticalPosition: 'top'
    }
  },
  {
    id: 'BB',
    title: 'Big Blind',
    description:
      'The Big Blind, an obligatory bet, initiated irrespective of the cards, setting the tone for the poker round. This position moves one to the left every hand.',
    marginBottom: Platform.OS === 'web' ? undefined : '50%',
    line: {
      type: 'clockwise',
      rotation: 180,
      horizontalPosition: 'right',
      verticalPosition: 'top'
    }
  },
  {
    id: 'hole',
    title: 'Your Hole Cards',
    description: 'Hole cards are the two private cards dealt face down to each player in poker.',
    marginBottom: undefined,
    line: {
      type: 'clockwise',
      rotation: 270,
      horizontalPosition: 'right',
      verticalPosition: 'bottom'
    }
  },
  {
    id: 'chips',
    title: 'Your Chips',
    description: 'Amount of chips you have to bet with.',
    marginBottom: Platform.OS === 'web' ? '-50%' : '-100%',
    line: {
      type: 'counterclockwise',
      rotation: 180,
      horizontalPosition: 'right',
      verticalPosition: 'bottom'
    }
  },
  {
    id: 'pot',
    title: 'The Pot',
    description:
      'The pot is the sum of all bets placed by the players in a poker hand. At the end of the round, the pot is awarded either to the player with the best hand or to the last remaining player in the hand.',
    marginBottom: undefined,
    line: undefined
  }
]
